import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LogTable } from "@/components/LogTable";
import { api, errMsg } from "@/lib/api";
import { downloadBlob } from "@/lib/exporters";
import { toast } from "sonner";

const fetchLogs = (p) => api.get("/audit-logs", { params: p });

export function AuditTab() {
  const backup = async () => {
    try {
      const r = await api.get("/backup", { responseType: "blob" });
      downloadBlob(r.data, `backup_${new Date().toISOString().slice(0, 10)}.json`);
      toast.success("Backup baixado");
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-4">
      <div className="card-surface p-5 flex flex-wrap items-center gap-3">
        <p className="text-sm flex-1">Baixe uma cópia completa dos dados do seu estabelecimento (produtos, clientes, vendas, estoque, caixa e mais) em formato JSON.</p>
        <Button variant="outline" onClick={backup} data-testid="download-backup-btn"><Download className="h-4 w-4 mr-2" />Baixar backup</Button>
      </div>
      <LogTable fetcher={fetchLogs} testId="audit-logs-table" />
    </div>
  );
}
